<template>
  <div class="dashboard">
    <el-backtop target=".content-box" :right="5" :bottom="105" />
    <div class="body" style="height: auto">
      <el-card class="box-card">
        <div class="header">
          <div class="header_title bold">
            未完成订单 （<span>{{ unCompleteOrders.length ? unCompleteOrders.length : 0 }}</span>）
          </div>
          <div class="header_right">
            <div class="header_item">
              <span class="item_title"> 时间选择：</span>
              <el-date-picker v-model="dateValue" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :editable="false" :clearable="false"
                @change="chooseDate">
              </el-date-picker>
            </div>
            <!-- <div class="header_item">
              <span class="item_title">报告状态：</span>
              <el-select v-model="typeValue" placeholder="请选择" @change="chooseType">
                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div> -->
            <!-- <div class="header_item">
              <el-input
                v-model="searchName"
                placeholder="输入患者姓名"
                clearable
                prefix-icon="el-icon-search"
                @clear="clearSearchName"
              ></el-input>
            </div> -->
            <div class="header_item">
              <el-button type="primary" plain icon="el-icon-search" size="small"
                @click="getUncompleteOrders">搜索</el-button>
              <el-button type="warning" icon="el-icon-s-promotion" style="height: 32px; margin-left: 50px"
                @click="payBatch">发起批量支付</el-button>
            </div>
          </div>
        </div>
        <div class="middle_table">
          <el-table :data="batchOrderArr" stripe empty-text="暂未选中需要批量支付的订单" style="width: 100%">
            <el-table-column type="index" label="序号" width="50" align="center"> </el-table-column>
            <el-table-column prop="DocumentNo" label="订单编号" align="center"> </el-table-column>
            <el-table-column prop="orsl_Order_summary_amount" label="订单金额" width="100" align="center">
            </el-table-column>
            <el-table-column prop="orsl_Consumer_name" label="姓名" width="100" align="center"> </el-table-column>
            <el-table-column prop="orsl_Consumer_gender" label="性别" width="100" align="center"> </el-table-column>
            <el-table-column prop="orsl_Consumer_age" label="年龄" width="100" align="center"> </el-table-column>
            <el-table-column prop="cml_Customer_ID" label="患者ID" width="180" align="center"> </el-table-column>
            <el-table-column prop="orsl_Consumer_mobile_number" label="手机号" width="140" align="center">
            </el-table-column>
            <el-table-column prop="Order_detail_barcode" label="条码" width="180" align="center">
              <template slot-scope="{ row }">
                <div v-for="(item, index) in row.Order_detail_barcode" :key="index">
                  {{ item.orcab_barcode ? item.orcab_barcode : '暂未填写' }}；
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="Creationtime" label="创建时间" width="160" align="center"> </el-table-column>
            <!-- <el-table-column prop="orsl_Settlement_time" label="结算时间" width="160" align="center"> </el-table-column> -->
            <el-table-column label="支付反馈" width="200" align="center">
              <template slot-scope="{ row }">
                <el-progress v-if="row.payTip === 1" type="circle" :percentage="100" status="success"></el-progress>
                <el-progress v-else-if="row.payTip === 2" type="circle" :percentage="100"
                  status="exception"></el-progress>
                <el-tag v-else type="info">暂未支付</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>

    <div class="orderBox" v-loading="loadingUncomplete" element-loading-text="未完成订单加载中"
      element-loading-spinner="el-icon-loading">
      <el-card class="orderCard" :id="'o-' + item.DocumentNo" v-for="(item, index) in unCompleteOrders" :key="index">
        <!-- <el-card class="orderCard"> -->
        <div class="title">
          <div class="orderTip">
            <div :class="item.state === '已填写' ? 'orderTipTop' : 'orderTipTopAct'">{{ item.state ? item.state : '未填写' }}
            </div>
            <div :class="item.orsl_Payment_status === '已结算' ? 'orderTipBottom' : 'orderTipTopAct'">
              {{ item.orsl_Payment_status ? item.orsl_Payment_status : '未结算' }}
            </div>
          </div>
          <span style="margin-left: 60px; width: 800px">
            <el-checkbox v-if="!item.orsl_Payment_status" size="medium" v-model="item.isChecked"
              @change="chooseOrder(item)"></el-checkbox>&nbsp;&nbsp;&nbsp;订单编号：{{ item.DocumentNo }}
          </span>
          <div class="deleteBtn" v-if="item.orsl_Payment_status !== '已结算'">
            <el-button v-if="item.orsl_Payment_status === '待支付' || item.orsl_Payment_status === '准备支付'" type="primary"
              icon="el-icon-refresh-left" plain style="height: 32px; margin-right: 20px"
              @click.stop="cancelOrderStatus2(item.DocumentNo)">撤销支付状态</el-button>
            <!-- <el-button type="success" icon="el-icon-edit-outline" plain style="height: 32px">申请改项</el-button> -->
            <el-button type="danger" icon="el-icon-delete" plain style="height: 32px"
              @click="deleteOrder(item.DocumentNo)">删除订单</el-button>
          </div>
        </div>
        <div class="info">
          {{ item.orsl_Consumer_name }}/{{ item.orsl_Consumer_gender }}/{{ item.orsl_Consumer_age }}/{{
            item.orsl_Consumer_mobile_number }}
          <span class="info_right">订单金额：￥{{ item.orsl_Order_summary_amount }}
            <!-- 诊所实付<span style="color: #f04562; cursor: pointer">:{{ totalRealMoney }}--{{ totalSalesMoney }}</span> -->
          </span>
        </div>
        <div class="info2">
          <span> {{ item.psl_name }}；</span>
        </div>
        <div class="orderContent">
          <div class="orderContent_left">
            <!-- 条形码区域 -->
            <div class="order_left">
              <div class="left_tm">条<br />码<br />填<br />写</div>
              <div class="left_content">
                <div class="code" v-for="(code, k3) in item.Order_detail_barcode" :key="k3">
                  <div class="code_img">
                    <img :src="getCodeImage(code.psl_Default_sample_consumables_code)"
                      style="width: 100%; height: 100%" />
                  </div>
                  <div class="code_right">
                    <div class="code_right_top">
                      <div class="code_inner_right"
                        :style="'background-color:' + getCodeColor(code.psl_Default_sample_consumables_code)"></div>
                      <div class="code_inner_left">{{ code.psl_Default_sample_consumables }}</div>
                    </div>
                    <div class="code_right_bottom">
                      <el-input v-model="code.orcab_barcode" placeholder="请输入"></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 科室检查区域 -->
            <div class="order_bottom" style="margin-top: 20px">
              <div class="bottom_tm">科<br />室<br />检<br />查</div>
              <div class="bottom_content" v-if="item.Order_detail_input && item.Order_detail_input.length > 0">
                <div class="department">
                  <div class="department_item" v-for="(depart, k6) in item.Order_detail_input" :key="k6">
                    <span class="item_name"> {{ depart.pdl_name }}：</span>
                    <el-input placeholder="请输入" v-model="depart.papdl_Results_description" class="item_input">
                      <template slot="append" v-if="depart.pdl_Return_value_unit">{{ depart.pdl_Return_value_unit
                        }}</template>
                    </el-input>
                  </div>
                </div>
                <div class="department_suggest">
                  <!-- <div class="suggest_top" style="margin-top: 5px">
                    <div class="top_title">身形评估：</div>
                    <div
                      :class="figureIindex === item.id ? 'top_tagactive' : 'top_tag'"
                      v-for="(item, index) in figureList"
                      :key="index"
                      @click="figureIindex = item.id"
                    >
                      {{ item.title }}
                    </div>
                  </div> -->
                  <div class="suggest_top" style="margin-top: 10px">
                    <div class="top_title" style="width: 120px">医生面检建议：</div>
                    <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="input2"> </el-input>
                  </div>
                </div>
              </div>
              <div class="bottom_contentImage" v-else>
                <div class="bottom_contentImage">
                  <img src="https://picture.aiyizhijian.com/image/png/647284620605719808.png" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div class="payment_panel" v-if="item.orsl_Payment_status !== '已结算'">
            <!-- <div class="pay_top" v-if="payTypeNum === 0">
              <span class="main-title text-color-primary">扫码支付</span>中健医学云平台 | 收银台
              <p class="subtitle text-color-warning">微信、支付宝都可扫二维码进行支付</p>
            </div> -->
            <div class="pay_top">
              <span class="main-title text-color-primary">检验钱包</span>医知检云平台 | 收银台
              <!-- <password-input class="subtitle" ref="myChild"></password-input>  -->
            </div>
            <div class="pay_carousel">
              <!-- <el-carousel indicator-position="none" :autoplay="false" ref="carousel" height="250px" @change="choosePayType">               
                <el-carousel-item name="swiperWallet">
                  <div class="swiper_image"><img src="@/assets/img/erweima.png" alt="" style="width: 100%; height: 100%" /></div>
                </el-carousel-item>
              </el-carousel> -->
              <div class="payWay">
                <div class="payType" @click.stop="choosePayType(item, 'Wallet')">
                  <div class="imageBox"><img src="../../../assets/img/wallet.png" class="payImage" alt /></div>
                  <div class="label">钱包支付</div>
                  <transition name="fade">
                    <img src="../../../assets/img/topTip.png" alt class="topTip"
                      v-show="item.payTypeNum === 'Wallet'" />
                  </transition>
                </div>
                <div class="payType" @click.stop="choosePayType(item, 'WeChat')">
                  <div class="imageBox"><img src="../../../assets/img/WX.png" class="payImage" alt /></div>
                  <div class="label">微信支付</div>
                  <transition name="fade">
                    <img src="../../../assets/img/topTip.png" alt class="topTip"
                      v-show="item.payTypeNum === 'WeChat'" />
                  </transition>
                </div>
              </div>
            </div>

            <div class="section_bottom">
              <div class="row flex flex-between">
                <div>
                  钱包金额：<span class="text-color-danger bold">￥{{ walletBalance }}</span>
                </div>
                <div>
                  E豆余额：<span class="text-color-danger bold">￥{{ pointsBalance }}</span>
                </div>
              </div>
              <div class="row">
                <span>使用余额：</span>
                <el-input size="small" type="number" v-model="item.orsl_Use_balance" placeholder="输入使用钱包金额"
                  @input="bindRecharge($event, item)"></el-input>
              </div>
              <div class="row">
                <span>使用E豆：</span>
                <el-input size="small" type="number" v-model="item.orsl_Using_points" placeholder="输入使用E豆金额"
                  @input="bindPoints($event, item)"></el-input>
              </div>
              <div class="row">
                微信支付金额：<span class="text-color-danger bold">￥{{ item.orsl_Using_wechat }}</span>
              </div>
              <el-button type="primary" size="small" @click="paySure(item)">确认支付</el-button>
            </div>
          </div>
        </div>

        <div class="bottom_btn">
          <div style="margin-right: 20px">
            开单医生：<el-select v-model="item.orsl_Billing_doctor_ID" placeholder="" style="width: 180px"
              @change="chooseBillingDoctor($event, item.DocumentNo)">
              <el-option v-for="item in billingDoctorList" :key="item.id" :label="item.caa_full_name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div style="margin-right: 20px">
            备注信息：<el-input placeholder="" v-model="item.orsl_remarks" style="width: 400px"> </el-input>
          </div>
          <el-button plain style="margin-left: 15px" icon="el-icon-error">取消</el-button>
          <el-button type="primary" plain icon="el-icon-success" @click="saveCodeAll(item)">保存</el-button>
        </div>
      </el-card>
    </div>
    <!-- 微信支付弹出层 -->
    <el-dialog :visible.sync="dialogWX" width="300px" class="dialogWXAdd" :show-close="false"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="dialogWalletContent">
        <div style="width: 100%; height: 30px; background-color: #fff"></div>
        <img src="../../../assets/img/WXbarcode.png" alt style="width: 100%" />
        <div id="qrCodeAdd" ref="qrCodeAdd"></div>
      </div>
      <div class="dialogWXBtn">
        <el-button type="info" icon="el-icon-error" @click="handleClosePassword2">取消支付</el-button>
        <el-button type="primary" icon="el-icon-success" @click="completePaySure">已&nbsp;支&nbsp;付</el-button>
      </div>
    </el-dialog>
    <!-- 自定义充值微信支付弹出层 -->
    <el-dialog :visible.sync="dialogZdWx" width="300px" class="dialogWXAdd" :show-close="false"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="dialogWalletContent">
        <div style="width: 100%; height: 30px; background-color: #fff"></div>
        <img src="../../../assets/img/WXbarcode.png" alt style="width: 100%" />
        <div id="qrCodeAddZd" ref="qrCodeAddZd"></div>
      </div>
      <div class="dialogWXBtn">
        <el-button type="info" icon="el-icon-error" @click="cancelZdRecharge">取消支付</el-button>
        <el-button type="primary" icon="el-icon-success" @click="playRechargeMark">已&nbsp;支&nbsp;付</el-button>
      </div>
    </el-dialog>
    <!-- 自定义充值 -->
    <el-dialog title="" :visible.sync="centerDialogVisible" width="30%" center :show-close="false"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="zdDialog">
        <p class="zdTitle">
          <span style="color: orange; font-size: 18px"><i class="el-icon-info"></i></span> 支付提示
        </p>
        <p class="zdTip">抱歉：此次批量支付你钱包余额不足支付你选中的订单的批量支付；</p>
        <p class="zdTip">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;请先充值后再进行批量支付；</p>
        <p class="zdTip2">
          批量支付差额(本次)：<span style="color: #f04562; font-weight: bold"> ￥{{ differenceAmount }}</span>
        </p>
        <div class="zdInput">
          <span style="color: #2d99d7"> 充值金额：</span>
          <el-input placeholder="" v-model.trim="rechargeAmount" type="number" style="width: 250px">
            <template slot="append">元</template>
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelZdCz">取消充值</el-button>
        <el-button type="primary" plain @click="confirmZdCz">确定充值</el-button>
      </span>
    </el-dialog>
    <!-- 批量支付弹出层 -->
    <el-dialog :visible.sync="dialogVisible" width="85%" top="2vh" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <template slot="title">
        <div class="patient_dialogheader">
          <div class="dialog_title" style="width: 100%; text-align: center">批量支付反馈</div>
          <!-- <div class="dialog_search">
            <el-input v-model.trim="dialogInputName" placeholder="搜索目的名称" clearable style="width: 300px; margin: 0 20px"></el-input>
            <el-button type="primary" plain style="width: 70px">查询</el-button>
          </div> -->
        </div>
      </template>
      <div class="more_test">
        <el-table :data="batchOrderArr" stripe empty-text="暂未选中需要批量支付的订单" style="width: 100%" height="100%">
          <el-table-column type="index" label="序号" width="50" align="center"> </el-table-column>
          <el-table-column prop="DocumentNo" label="订单编号" align="center"> </el-table-column>
          <el-table-column prop="orsl_Order_summary_amount" label="订单金额" width="100" align="center"> </el-table-column>
          <el-table-column prop="orsl_Consumer_name" label="姓名" width="100" align="center"> </el-table-column>
          <el-table-column prop="orsl_Consumer_gender" label="性别" width="100" align="center"> </el-table-column>
          <el-table-column prop="orsl_Consumer_age" label="年龄" width="100" align="center"> </el-table-column>
          <el-table-column prop="cml_Customer_ID" label="患者ID" width="180" align="center"> </el-table-column>
          <el-table-column prop="orsl_Consumer_mobile_number" label="手机号" width="140" align="center"> </el-table-column>
          <el-table-column prop="Order_detail_barcode" label="条码" width="180" align="center">
            <template slot-scope="{ row }">
              <div v-for="(item, index) in row.Order_detail_barcode" :key="index">
                {{ item.orcab_barcode ? item.orcab_barcode : '暂未填写' }}；
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Creationtime" label="创建时间" width="160" align="center"> </el-table-column>
          <!-- <el-table-column prop="orsl_Settlement_time" label="结算时间" width="160" align="center"> </el-table-column> -->
          <el-table-column label="支付反馈" width="200" align="center">
            <template slot-scope="{ row }">
              <el-progress v-if="row.payTip === 1" type="circle" :percentage="100" status="success"></el-progress>
              <el-progress v-else-if="row.payTip === 2" type="circle" :percentage="100"
                status="exception"></el-progress>
              <el-tag v-else type="info">暂未支付</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="text-right" slot="footer">
        批量共支付 <span class="bold" style="color: #409eff"> {{ batchOrderArr.length }}</span> 笔订单，合计金额：
        <span class="bold" style="color: #409eff">{{ batchTotalMoeny.toFixed(2) }}; </span> &nbsp;&nbsp; 成功支付
        <span class="bold" style="color: #67c23a"> {{ batchSuccessNumber }}</span> 笔订单，合计金额：
        <span class="bold" style="color: #67c23a">￥{{ batchSuccessMoeny.toFixed(2) }}; </span> &nbsp;&nbsp; 支付失败
        <span class="bold text-color-danger">{{ batchErrorNumber }}</span> 笔订单，合计金额：<span
          class="bold text-color-danger">￥{{
            batchErrorMoeny.toFixed(2) }}
        </span>
        <el-button type="primary" plain style="margin-left: 20px" @click="confirmFk">确定反馈</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import request from '@/utils/request';
import moment from 'moment';
import codeImageList from '@/utils/codeImage.js';
import passwordInput from '@/components/common/passwordInput';
import QRCode from 'qrcodejs2'; //二维码

export default {
  name: 'Uncomplete',
  components: {
    passwordInput
  },

  data() {
    return {
      loadingPay: false, //支付中转圈圈
      loadingUncomplete: false, //加载转圈圈
      totalBatchMoeny: 0, //批量总金额
      centerDialogVisible: false, //自定义充值显示
      dialogZdWx: false, //自定义充值弹出层
      rechargeorderNum: '', //自定充值订单编号
      differenceAmount: 0, //差值金额
      rechargeAmount: 0, //自定义充值金额

      currentDocumentNo: '', //当前订单号
      timer: null, //定时器
      dialogWX: false, //微信支付

      clinicInfo: {}, // 诊所基本信息
      clinicInfoGp: {}, // 诊所基本信息

      DocumentNo: '', //订单号
      codeList: [], //条码列表
      orderRemark: '', //订单备注信息
      billingDoctorList: [], //诊所医生列表

      payTypeNum: 0, //0是微信扫码 2是钱包支付
      walletBalance: 0, //钱包余额
      pointsBalance: 0, //E豆余额
      realTotalMoeny: 0, //实付总价
      useWalletPay: 0, //实付余额支付
      usePointsPay: 0, //实付E豆支付
      waitPay: 0, //待支付金额
      payTypeNum: 'Wallet', //WeChat是微信扫码 Wallet是钱包支付

      figureIindex: 1,
      figureList: [
        {
          id: 1,
          title: '标准'
        },
        {
          id: 2,
          title: '偏胖'
        },
        {
          id: 3,
          title: '肥胖'
        },
        {
          id: 4,
          title: '偏瘦'
        },
        {
          id: 5,
          title: '消瘦'
        }
      ],
      input2: '',
      input: '',
      dateValue: '', //选择时间
      chooseProductArr: [], //首页已选项目
      unCompleteOrders: [], //未完成订单列表
      batchOrderArr: [], //批量支付数组
      dialogVisible: false, //弹出层
      batchTotalMoeny: 0, //总
      batchSuccessNumber: 0, //成功笔数
      batchSuccessMoeny: 0, //成功总金额
      batchErrorNumber: 0, //失败笔数
      batchErrorMoeny: 0 //失败总金额
    };
  },
  async created() {
    this.clinicInfoGp = JSON.parse(sessionStorage.user);
    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
    this.startTime = moment(new Date().getTime() - 7000 * 60 * 60 * 24).format('YYYY-MM-DD');
    this.dateValue = [this.startTime, this.endTime]; //回显

    this.getClinicBalance(); //获取诊所余额E豆
    this.getClinicInfo(); //获取诊所基本信息
    await this.getBillingDoctor(); //拉取诊所医生
    await this.getUncompleteOrders();
  },
  mounted() { },
  computed: {
    // 实付价
    totalSalesMoney() {
      let sum = 0;
      if (this.chooseProductArr.length > 0) {
        this.chooseProductArr.map((item) => {
          sum += Number(item.psl_selling_price);
        });
        return sum.toFixed(2);
      } else {
        return 0.0;
      }
    },
    //产品总物价
    totalRealMoney() {
      let sum2 = 0;
      if (this.chooseProductArr.length > 0) {
        this.chooseProductArr.map((item) => {
          sum2 += Number(item.price);
        });
        return sum2.toFixed(2);
      } else {
        return 0.0;
      }
    }
  },
  methods: {
    // ----------------自定义充值--------------------
    cancelZdCz() {
      this.centerDialogVisible = false; //先关闭充值弹出层
      this.rechargeAmount = '';
    },
    // 确认充值
    async confirmZdCz() {
      const that = this;
      if (that.rechargeAmount <= 0) {
        that.$message.error('抱歉，充值金额不可以小于或等于零');
        return false;
      }
      that.centerDialogVisible = false; //先关闭充值弹出层

      
      //朱凡新批量支付接口
        console.log('批量支付订单号11', that.batchOrderArr)
        const documentNos = that.batchOrderArr.map((item)=>item.DocumentNo)
      const params = {
             calCode: that.clinicInfoGp.cal_code,
              payWay: 'outer-wechat',
              payType:'h5',
              payAmount: that.rechargeAmount,
              documentNoList: documentNos
      }
      await request.post('/inputOrder/batchPayByRechargeCreate', params, { category: 'ZhuFan' })
        .then(async (res) => {
          console.log('res', res)
          if (res.success) {
            const param = {
              calCode: that.clinicInfoGp.cal_code,
              amount: that.rechargeAmount,
              id: res.data.id
            }
            const paramStr= encodeURIComponent(JSON.stringify(param))
            console.log('参数',paramStr)
            const url = `https://admin.aiyizhijian.com/ysb-pay/wxpay-batch.html?param=${paramStr}`
            console.log('长度',url.length)
            that.dialogZdWx = true;
            await that.createQrcodeZd(url);
          } else {
             that.$message.error('抱歉，批量支付异常');
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，批量支付异常');
        });
       
       
       

      //批量支付孙总老接口20251117
      // let dataC = {
      //   cal_code: that.clinicInfoGp.cal_code,
      //   rcs_Recharge_amount: that.rechargeAmount
      // };
      // const params = {
      //   token: that.clinicInfoGp.token,
      //   workid: '9f5f2c5b-0ef7-08ff-276f-6c666cff5279',
      //   data: JSON.stringify(dataC)
      // };
      // await request
      //   .post('/server/getdatalisapi.php', params)
      //   .then(async (res) => {
      //     if (res.Recharge_order.IsOk === 'success') {
      //       const orderNum = res.Recharge_order.Data.detail.DocumentNo.DocumentNo[0].DocumentNo;
      //       that.rechargeorderNum = res.Recharge_order.Data.detail.DocumentNo.DocumentNo[0].DocumentNo;
      //       that.createOrder(orderNum);
      //     } else {
      //       that.$message.error('抱歉，生成充值订单失败');
      //     }
      //   })
      //   .catch((err) => { });
    },
    // 打开自定义充值
    async openCharge() {
      this.centerDialogVisible = true; //先关闭充值弹出层
    },
    //创建自定义充值订单
    async createOrder(documentno) {
      const that = this;
      let dataP = {
        DocumentNo: documentno
      };
      const params = {
        openid: '',
        token: that.clinicInfoGp.token,
        userurl: 'https://cloud.hwason.cn/',
        data: JSON.stringify(dataP)
      };
      await request
        .post('/server/weixinpay.php', params)
        .then(async (res) => {
          // console.log('生成二维码返回值：', res[1].code_url);
          if (res[1].return_msg === 'OK' && res[1].code_url) {
            await that.getStatusByOrder(documentno);
          } else {
            that.$message.error('抱歉，微信支付失败，生成微信支付二维码失败');
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，微信支付失败，生成微信支付二维码失败');
        });
    },
    // 拉取二维码（聚合支付）
    async getStatusByOrder(documentno) {
      const that = this;
      let dataR = {
        DocumentNo: documentno,
        cal_code: that.clinicInfoGp.cal_code
      };
      const params = {
        token: that.clinicInfoGp.token,
        workid: '0c48295c-c114-bb66-ff4e-ca70c87b2c64',
        data: JSON.stringify(dataR)
      };
      await request
        .post('/server/getdatalisapi.php', params)
        .then(async (res) => {
          if (res.recharge_order && res.recharge_order[0].rco_nwx_h5url) {
            that.dialogZdWx = true;
            await that.createQrcodeZd(res.recharge_order[0].rco_nwx_h5url);
          } else {
            that.$message.error('抱歉,生成充值二维码失败');
          }
        })
        .catch((err) => { });
    },


    // 支付二维码生成
    createQrcodeZd(value) {
      this.$nextTick(() => {
        document.getElementById('qrCodeAddZd').innerHTML = '';
        let qrcode = new QRCode('qrCodeAddZd', {
          width: 110,
          height: 110, // 高度
          text: value
        });
      });
    },
    //取消充值
    cancelZdRecharge() {
      this.dialogZdWx = false;
      this.rechargeorderNum = '';
      this.rechargeAmount = '';
    },
    // 确认已充值
    async playRechargeMark() {
      const that = this;
      if (!this.rechargeorderNum) {
         that.dialogZdWx = false;
        return false;
      }
      let dataR = {
        DocumentNo: that.rechargeorderNum
      };
      const params = {
        token: that.clinicInfoGp.token,
        workid: 'd8b10a8c-feb1-e0d8-04df-835f9dbd8b77',
        data: JSON.stringify(dataR)
      };
      await request.post('/server/weixinpaysettlement.php', params).then((res) => {
        that.dialogZdWx = false;
        that.rechargeorderNum = '';
        that.rechargeAmount = '';
        that.getClinicBalance(); //获取诊所余额E豆
      });
    },
    // ----------------自定义充值结束--------------------
    // 选择类型
    choosePayType(item, val) {
      item.payTypeNum = val;
      if (val === 'WeChat') {
        // 微信支付
        item.orsl_Use_balance = 0;
        item.orsl_Using_points = 0;
        item.orsl_Using_wechat = Number(item.orsl_Order_summary_amount);
      } else {
        //钱包支付
        item.orsl_Use_balance = Number(item.orsl_Order_summary_amount);
        item.orsl_Using_points = 0;
        item.orsl_Using_wechat = 0;
      }
    },
    // 取消微信支付
    handleClosePassword2() {
      this.dialogWX = false;
      // clearInterval(this.timer); //清除定时器
      this.cancelOrderStatus(this.currentDocumentNo);
    },
    // 已支付
    completePaySure() {
      this.completeWxPayOrder();
      this.confirmFk();
      this.dialogWX = false;
    },
    // 确认反馈
    confirmFk() {
      const that = this;
      that.dialogVisible = false;
      that.batchOrderArr = [];
      that.batchTotalMoeny = 0;
      that.batchSuccessNumber = 0;
      that.batchSuccessMoeny = 0;
      that.batchErrorNumber = 0;
      that.batchErrorMoeny = 0;
      that.currentDocumentNo = '';
      that.getUncompleteOrders();
    },
    //选择支付
    async chooseOrder(item) {
      const that = this;
      const isExist = that.batchOrderArr.find((key) => key.DocumentNo === item.DocumentNo);
      if (isExist) {
        that.batchOrderArr = that.batchOrderArr.filter((row) => row.DocumentNo !== item.DocumentNo);
      } else {
        that.batchOrderArr.push(item);
      }
    },

    async payBatch() {
      const that = this;
      if (that.batchOrderArr.length === 0) {
        that.$message.warning('请先选择需要批量支付的订单');
        return false;
      }
      // 判断诊所余额够不够支付这些订单总和（这边没考虑E豆）
      that.totalBatchMoeny = 0;
      that.batchOrderArr.map((item) => {
        that.totalBatchMoeny += Number(item.orsl_Order_summary_amount);
      });
      if (Number(that.totalBatchMoeny) > Number(that.walletBalance)) {
        that.centerDialogVisible = true;
        that.differenceAmount = (Number(that.totalBatchMoeny) - Number(that.walletBalance)).toFixed(2);
        that.rechargeAmount = that.differenceAmount;
        return false;
      }
      //判断成功通过后
      that.dialogVisible = true; //支付反馈弹出层
      for (let i in that.batchOrderArr) {
        // 处理异步
        const params = {
           calCode: that.clinicInfoGp.cal_code,
           documentNoList:[that.batchOrderArr[i].DocumentNo]
        }
        await request.post('/inputOrder/batchSettlement', params, { category: 'ZhuFan' })
        .then((res) => {
          console.log('res', res)
          if (res.success) {
            that.$set(that.batchOrderArr[i], 'payTip', 1);
          } else {
             that.$set(that.batchOrderArr[i], 'payTip', 2);
            // that.$message.error('抱歉，支付失败');
            that.cancelOrderStatus(documentno);
          }
        })
        .catch((err) => {
          that.$set(that.batchOrderArr[payindex], 'payTip', 2);
          console.log('批量支付-单个支付，',err)
          // that.$message.error('支付失败');
          that.cancelOrderStatus(item.DocumentNo);
        });
        //苏总旧批量支付的调用
        // await that.payBatchFirst(that.batchOrderArr[i], Number(i), that.batchOrderArr.length);
        //弹窗显示提示
        if (Number(i) + 1 === that.batchOrderArr.length) {
          console.log('11',that.batchOrderArr)
          that.$message.warning('提示：已选订单支付全部结束');
          that.batchOrderArr.map((item) => {
            that.batchTotalMoeny += Number(item.orsl_Order_summary_amount);
            if (item.payTip === 1) {
              that.batchSuccessNumber++;
              that.batchSuccessMoeny += Number(item.orsl_Order_summary_amount);
            } else if (item.payTip === 2) {
              that.batchErrorNumber++;
              that.batchErrorMoeny += Number(item.orsl_Order_summary_amount);
            }
          });
          that.getUncompleteOrders();
        }
      }
    },
    // 批量===支付
    async payBatchFirst(item, payindex, length) {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        DocumentNo: item.DocumentNo,
        orsl_Use_balance: item.orsl_Use_balance ? item.orsl_Use_balance : 0,
        orsl_Using_points: item.orsl_Using_points ? item.orsl_Using_points : 0
      };
      const params = {
        token: clinicInfo.token,
        workid: '38d22bf5-cd38-c879-f2db-7ca9ae225958',
        data: JSON.stringify(dataP)
      };
      await request
        .post('/server/getdatalisapi.php', params)
        .then(async (res) => {
          if (res.Order_summary_Library.IsOk === 'success') {
            // that.$message.success('恭喜，第一次锁单成功');
            await that.goBatchWalletPay(item.DocumentNo, payindex, length);
          } else {
            // that.$message.error('抱歉，锁单支付失败');
            that.$set(that.batchOrderArr[payindex], 'payTip', 2);
            that.cancelOrderStatus(item.DocumentNo);
          }
        })
        .catch((err) => {
          that.$set(that.batchOrderArr[payindex], 'payTip', 2);
          that.cancelOrderStatus(item.DocumentNo);
        });
    },
    //批量===钱包支付
    async goBatchWalletPay(documentno, payindex, length) {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        DocumentNo: documentno,
        SourceID: ''
      };
      const params = {
        token: clinicInfo.token,
        workid: 'e3a71260-6f99-847b-26d3-b601f015cbf3',
        data: JSON.stringify(dataP)
      };
      await request
        .post('/server/getdatalisapi.php', params)
        .then(async (res) => {
          if (res.Settlement_sales_summary_Library.IsOk === 'success') {
            that.$set(that.batchOrderArr[payindex], 'payTip', 1);
          } else {
            that.$set(that.batchOrderArr[payindex], 'payTip', 2);
            // that.$message.error('抱歉，支付失败');
            that.cancelOrderStatus(documentno);
          }
        })
        .catch((err) => {
          that.$set(that.batchOrderArr[payindex], 'payTip', 2);
          // that.$message.error('抱歉，支付失败');
          that.cancelOrderStatus(documentno);
        });
    },
    // 选择时间
    chooseDate(event) {
      if (event) {
        this.startTime = event[0];
        this.endTime = event[1];
      } else {
        this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
        this.startTime = moment(new Date().getTime() - 1000 * 60 * 60 * 24).format('YYYY-MM-DD');
      }
      this.getUncompleteOrders();
    },

    //拉取未完成订单
    getUncompleteOrders() {
      const that = this;
      that.loadingUncomplete = true;
      let dataP = {
        cal_code: that.clinicInfoGp.cal_code,
        ksdate: that.startTime,
        jsdate: that.endTime
      };
      const params = {
        token: that.clinicInfoGp.token,
        workid: '0f8f3930-3136-6920-561d-685a4407f5ea',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          that.loadingUncomplete = false;
          that.unCompleteOrders = res.Order_summary_Library.filter((item) => item.orsl_Consumer_name);
          that.unCompleteOrders.map((item) => {
            item.orsl_Use_balance = Number(item.orsl_Order_summary_amount);
            that.$set(item, 'isChecked', false);
            that.$set(item, 'payTypeNum', 'Wallet');
          });
          // console.log('查询未完成订单：：', that.unCompleteOrders);
        })
        .catch((err) => {
          that.loadingUncomplete = false;
        });
    },
    // 撤销支付状态two
    cancelOrderStatus2(documentno) {
      const that = this;
      let dataP = {
        DocumentNo: documentno
      };
      const params = {
        token: that.clinicInfoGp.token,
        workid: '54c54a4e-bf2f-cfaf-987e-7c56fc770d98',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          that.$message.success('提示：此订单状态撤销成功，请重新支付');
          that.getUncompleteOrders();
        })
        .catch((err) => { });
    },
    // 撤销支付状态
    cancelOrderStatus(documentno) {
      const that = this;
      let dataP = {
        DocumentNo: documentno
      };
      const params = {
        token: that.clinicInfoGp.token,
        workid: '54c54a4e-bf2f-cfaf-987e-7c56fc770d98',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          that.getUncompleteOrders();
        })
        .catch((err) => { });
    },
    // 微信支付后朝后台打标记
    completeWxPayOrder() {
      const that = this;
      let dataP = {
        DocumentNo: that.currentDocumentNo
      };
      const params = {
        token: that.clinicInfoGp.token,
        userurl: 'https://cloud.hwason.cn/',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/weixinpayddsettlement.php', params)
        .then((res) => {
          // console.log('微信支付后回调', res);
        })
        .catch((err) => { });
    },
    // 支付二维码生成
    createQrcode(value) {
      this.$nextTick(() => {
        document.getElementById('qrCodeAdd').innerHTML = '';
        let qrcode = new QRCode('qrCodeAdd', {
          width: 110,
          height: 110, // 高度
          text: value
        });
      });
    },
    // 获取订单详情根据订单号2
    async getOrderInfoByDocumentNo2(documentno) {
      const that = this;
      let dataP = {
        DocumentNo: documentno
      };
      const params = {
        token: that.clinicInfoGp.token,
        workid: '11792016-5732-aa16-76fa-66b1a1d3dca1',
        data: JSON.stringify(dataP)
      };
      await request
        .post('/server/getdatalisapi.php', params)
        .then(async (res) => {
          // console.log('订单详情明细：：：', res.Order_summary_Library[0]);
          const urlWx = res.Order_summary_Library[0].rco_nwx_h5url; //支付路径
          that.currentDocumentNo = res.Order_summary_Library[0].DocumentNo; //后台打标记订单号
          if (urlWx) {
            that.dialogWX = true;
            await that.createQrcode(urlWx);
          } else {
            that.$message.error('抱歉,生成微信支付二维码失败，请重新支付');
            that.cancelOrderStatus(documentno);
          }
        })
        .catch((err) => {
          that.cancelOrderStatus(documentno);
        });
    },
    //微信支付
    async goWeChatPay(documentno) {
      const that = this
      that.dialogWX = true;
      await that.createQrcode(`https://admin.aiyizhijian.com/ysb-pay/wxpay.html?orderNo=${documentno}`);
      
      //苏总支付接口20251116
      // let dataP = {
      //   DocumentNo: documentno
      // };
      // const params = {
      //   openid: '',
      //   token: that.clinicInfoGp.token,
      //   userurl: 'https://cloud.hwason.cn/',
      //   data: JSON.stringify(dataP)
      // };
      // await request
      //   .post('/server/weixinpaydd.php', params)
      //   .then(async (res) => {
      //     await that.getOrderInfoByDocumentNo2(documentno);
      //   })
      //   .catch((err) => {
      //     that.$message.error('抱歉，微信支付失败，请重新支付');
      //     that.cancelOrderStatus(documentno);
      //   });
    },

    //钱包支付
    goWalletPay(documentno) {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        DocumentNo: documentno,
        SourceID: ''
      };
      const params = {
        token: clinicInfo.token,
        workid: 'e3a71260-6f99-847b-26d3-b601f015cbf3',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then(async (res) => {
          if (res.Settlement_sales_summary_Library.IsOk === 'success') {
            that.$message.success('恭喜，支付成功');
            that.getUncompleteOrders();
            that.getClinicBalance(); //获取诊所余额E豆
          } else {
            that.$message.error('抱歉，支付失败');
            that.cancelOrderStatus(documentno);
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，支付失败');
          that.cancelOrderStatus(documentno);
        });
    },
    // 确定支付
    async paySure(item) {
      // console.log('啊哈哈哈：：', item);
      const that = this;
      // 微信支付非0判断
      if (item.payTypeNum === 'WeChat') {
        if (Number(item.orsl_Using_wechat) <= 0) {
          this.$confirm(
            '抱歉：选择微信支付时请确保微信支付金额大于0;请重新组合余额和E豆使用金额，确保使用微信支付金额大于0；',
            '微信支付提示',
            {
              confirmButtonText: '我已知晓',
              cancelButtonText: '取消',
              type: 'warning',
              center: true,
              showClose: false,
              showCancelButton: false,
              closeOnClickModal: false
            }
          ).then(() => { });
          return false;
        }
      }

      //账户余额E豆校验（够不够支付）
      if (Number(item.orsl_Use_balance) > Number(that.walletBalance) || Number(item.orsl_Using_points) > Number(that.pointsBalance)) {
        that
          .$confirm(
            '抱歉：诊所余额已不足支付你此笔订单使用的余额或E豆;请先保存提交订单，充值后再进行支付或者选择微信支付此笔订单',
            '支付提示',
            {
              confirmButtonText: '我已知晓',
              cancelButtonText: '取消',
              type: 'warning',
              center: true,
              showClose: false,
              showCancelButton: false,
              closeOnClickModal: false
            }
          )
          .then(() => { });
        return false;
      }

      // 钱包支付非0判断
      if (item.payTypeNum === 'Wallet') {
        if (Number(item.orsl_Using_wechat) !== 0) {
          that
            .$confirm('抱歉：选择钱包支付时请确保微信支付金额为0;请重新组合余额和E豆使用金额，确保使用微信支付金额为0；', '钱包支付提示', {
              confirmButtonText: '我已知晓',
              cancelButtonText: '取消',
              type: 'warning',
              center: true,
              showClose: false,
              showCancelButton: false,
              closeOnClickModal: false
            })
            .then(() => { });
          return false;
        }
      }
      //走支付 新接口
      if (item.payTypeNum === 'WeChat') {
        await this.wxPay(item);
      } else {
           const params = {
           calCode: that.clinicInfoGp.cal_code,
           documentNoList:[item.DocumentNo]
        }
        await request.post('/inputOrder/batchSettlement', params, { category: 'ZhuFan' })
        .then((res) => {
          console.log('res', res)
         if (res.success) {
            that.$message.success('恭喜，支付成功');
            that.getUncompleteOrders();
            that.getClinicBalance(); //获取诊所余额E豆
          } else {
            that.$message.error('抱歉，支付失败');
            that.cancelOrderStatus(documentno);
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，支付失败');
          that.cancelOrderStatus(documentno);
        });
      }

       //苏总旧接口20251118
        // if (item.orsl_Payment_status === '准备支付' || item.orsl_Payment_status === '待支付') {
        //   await this.paySecondAgain(item);
        // } else {
        //   // console.log('走支付了 哈哈哈');
        //   await this.payFirst(item);
        // }

    },
    //朱凡的新接口
    wxPay(item) {
      const that = this;
      const params = {
        documentno: item.DocumentNo,
        orslUseBalance: item.orsl_Use_balance ? item.orsl_Use_balance : 0,
        orslUsingPoints: item.orsl_Using_points ? item.orsl_Using_points : 0,
        orslUsingWechat: item.orsl_Using_wechat ? item.orsl_Using_wechat : 0,
      }
      request.post('/pay/orderLockedToPay', params, { category: 'ZhuFan' })
        .then((res) => {
          console.log('res', res)
          if (res.success) {
            console.log('res锁单：', res)
            that.goWeChatPay(item.DocumentNo)
          } else {
            that.$message.error(res.errMsg);
          }
        })
        .catch((err) => {
          that.$message.error('锁单失败');
          // that.cancelOrderStatus(item.DocumentNo);
        });
    },
    // 第一次支付
    payFirst(item) {
      const that = this;
      let dataP = {
        DocumentNo: item.DocumentNo,
        orsl_Use_balance: item.orsl_Use_balance ? item.orsl_Use_balance : 0,
        orsl_Using_points: item.orsl_Using_points ? item.orsl_Using_points : 0
      };
      const params = {
        token: that.clinicInfoGp.token,
        workid: '38d22bf5-cd38-c879-f2db-7ca9ae225958',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          if (res.Order_summary_Library.IsOk === 'success') {
            that.$message.success('恭喜，第一次锁单成功');
            if (item.payTypeNum === 'Wallet') {
              that.goWalletPay(item.DocumentNo); //钱包支付
            } else if (item.payTypeNum === 'WeChat') {
              that.goWeChatPay(item.DocumentNo); //微信支付
            } else {
              that.$message.warning('抱歉，暂未检测出你要选择的支付方式');
              that.cancelOrderStatus(item.DocumentNo);
            }
          } else {
            that.$message.error('抱歉，第一次锁单失败');
            that.cancelOrderStatus(item.DocumentNo);
          }
        })
        .catch((err) => {
          that.$message.error('抱歉，第一次锁单失败');
          that.cancelOrderStatus(item.DocumentNo);
        });
    },
    // 二次支付重新锁单
    paySecondAgain(item) {
      const that = this;
      let dataP = {
        DocumentNo: item.DocumentNo,
        orsl_Use_balance: item.orsl_Use_balance ? item.orsl_Use_balance : 0,
        orsl_Using_points: item.orsl_Using_points ? item.orsl_Using_points : 0
      };
      const params = {
        token: that.clinicInfoGp.token,
        workid: 'ff98da06-c0d9-d97b-fe19-a239b3d3595e',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          if (res.Order_summary_Library.IsOk === 'success') {
            that.$message.success('恭喜，再一次锁单成功');
            if (item.payTypeNum === 'Wallet') {
              that.goWalletPay(item.DocumentNo); //钱包支付
            } else if (item.payTypeNum === 'WeChat') {
              that.goWeChatPay(item.DocumentNo); //微信支付
            } else {
              that.$message.warning('抱歉，暂未检测出你要选择的支付方式');
              that.cancelOrderStatus(item.DocumentNo);
            }
          } else {
            that.$message.error('抱歉，再一次锁单支付失败,请重新支付');
            that.cancelOrderStatus(item.DocumentNo);
          }
        })
        .catch((err) => {
          that.cancelOrderStatus(item.DocumentNo);
        });
    },
    // 输入余额
    bindRecharge(event, item) {
      const that = this;
      item.orsl_Use_balance = Number(event);
      if (Number(event) > that.walletBalance) {
        that.$message.error('抱歉，超出钱包余额');
        item.orsl_Use_balance = 0;
        return false;
      } else {
        if (Number(event) > item.orsl_Order_summary_amount) {
          item.orsl_Use_balance = item.orsl_Order_summary_amount;
        }
      }

      item.orsl_Using_wechat = (
        Number(item.orsl_Order_summary_amount) -
        Number(item.orsl_Use_balance) -
        Number(item.orsl_Using_points)
      ).toFixed(2);
    },
    // 输入e豆
    bindPoints(event, item) {
      const that = this;
      if (Number(event) > that.pointsBalance) {
        that.$message.error('抱歉，超出E豆余额');
        item.orsl_Using_points = 0;
        return false;
      } else {
        if (Number(event) > item.orsl_Order_summary_amount) {
          item.orsl_Using_points = item.orsl_Order_summary_amount;
        }
      }
      item.orsl_Use_balance = (Number(item.orsl_Order_summary_amount) - Number(item.orsl_Using_points)).toFixed(2);
      item.orsl_Using_wechat = (
        Number(item.orsl_Order_summary_amount) -
        Number(item.orsl_Use_balance) -
        Number(item.orsl_Using_points)
      ).toFixed(2);
    },
    // 拉取诊所余额、E豆
    getClinicBalance() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataZ = {
        token: clinicInfo.token,
        workid: 'cfd7aec3-eb6f-cdbc-e7ef-79c7f92954b1'
      };
      request
        .post('/server/getdatalisapi.php', dataZ)
        .then((res) => {
          that.pointsBalance = Number(res.Channel_Library[0].cal_Points_balance); //E豆
          that.walletBalance = Number(res.Channel_Library[0].cal_Recharge_balance); //钱包余额
        })
        .catch((err) => { });
    },
    // 获取订单详情根据订单号
    getOrderInfoByDocumentNo() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        DocumentNo: that.DocumentNo
      };
      const params = {
        token: clinicInfo.token,
        workid: '11792016-5732-aa16-76fa-66b1a1d3dca1',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          const orderStorage = res.Order_summary_Library[0];
          that.useWalletPay = Number(orderStorage.orsl_Order_summary_amount); //订单金额
          that.realTotalMoeny = Number(orderStorage.orsl_Order_summary_amount); //订单总金额
          that.codeList = res.Order_summary_Library[0].Order_detail_barcode; //条码
          that.getClinicBalance(); //拉取诊所余额E豆
          that.modifyDoctor(orderStorage.DocumentNo, clinicInfo.sysusername, clinicInfo.sysuser, 'first'); //给此订单绑定开单医生
          // 滑动到此单输入条码位置
          that.$nextTick(() => {
            const container = document.querySelector('#content-box');
            const top = document.querySelector('#o-' + orderStorage.DocumentNo).offsetTop;
            container.scroll({ top, behavior: 'smooth' });
          });
        })
        .catch((err) => { });
    },
    //保存条码与科室检查
    saveCode() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        DocumentNo: that.DocumentNo,
        orsl_remarks: that.orderRemark,
        Order_detail_barcode: that.codeList,
        Order_detail_input: []
      };
      const params = {
        token: clinicInfo.token,
        workid: '882ae14c-49e8-23ae-0ea1-b11ef9bdf4c8',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          if (res.order_summary_library.IsOk === 'success') {
            that.$message.success('恭喜，保存信息成功');
          } else {
            that.$message.error('抱歉，保存信息失败');
          }
        })
        .catch((err) => { });
    },
    saveCodeAll(item) {
      const that = this;
      let dataP = {
        DocumentNo: item.DocumentNo,
        orsl_remarks: item.orsl_remarks,
        Order_detail_barcode: item.Order_detail_barcode,
        Order_detail_input: item.Order_detail_input
      };
      const params = {
        token: that.clinicInfoGp.token,
        workid: '882ae14c-49e8-23ae-0ea1-b11ef9bdf4c8',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          if (res.order_summary_library.IsOk === 'success') {
            that.$message.success('恭喜，保存信息成功');
            that.getUncompleteOrders(); //重新拉取
          } else {
            that.$message.error('抱歉，保存信息失败');
          }
        })
        .catch((err) => { });
    },

    //获取诊所详情
    getClinicInfo() {
      const user = JSON.parse(sessionStorage.user);
      let arrP = {
        cal_code: user.cal_code, // 诊所编号
        DisableState: 'F'
      };
      const params = {
        datatab: 'Channel_Library',
        select: '*',
        obgb: 'and cal_code is not null',
        LIKE: 'nl',
        data: JSON.stringify(arrP)
      };
      request.post('/server/getkehulbapi.php', params).then((res) => {
        this.clinicInfo = res[0];
        localStorage.clinicInfo = JSON.stringify(res[0]);
      });
    },

    // 删除订单
    deleteOrder(value) {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      that
        .$confirm('确定要删除此订单吗？', '提示', {
          type: 'warning'
        })
        .then(() => {
          let dataP = {
            DocumentNo: value,
            cal_code: clinicInfo.cal_code
          };
          const params = {
            token: clinicInfo.token,
            workid: 'a5c8b816-7a6b-74c0-eadf-0e1fb362f82d',
            data: JSON.stringify(dataP)
          };
          request
            .post('/server/getdatalisapi.php', params)
            .then((res) => {
              if (res.delOrder_detail_Library.IsOk === 'success') {
                that.$message.success('恭喜，删除订单成功');
                that.getUncompleteOrders();
              } else {
                that.$message.error('抱歉，删除订单失败');
              }
            })
            .catch((err) => { });
        })
        .catch(() => {
          that.$message.info('已取消删除');
        });
    },
    //拉去开单医生列表
    getBillingDoctor() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        cal_code: clinicInfo.hsp_code //诊所编码
      };
      const params = {
        token: clinicInfo.token,
        datatab: 'a585z+zUMw/5PjgSz+jlvMpBhOKvXHLJMeQCh8evMRjiGda9pDdvDY5JSn4', //对应表名
        select: '6e568HU7SMmtek9l3WYv+xF5xrJJgTUp4fOw85JM', //需要字段的名字
        obgb: 'f697fpmp1RK5nYKXAqCoZ4o7KPdlkrFGXPYZ4HR5hLG4f/mqOq/LxamLNmbtln7e//8uITuafUeYZRX29Ps050P7mxSXH//HKy0', //不动
        LIKE: 'nl',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getkehulbapi.php', params)
        .then((res) => {
          if (clinicInfo.Operatoridentity == 'admin') {
            const doctorMaster = [
              {
                caa_full_name: clinicInfo.sysusername,
                Operatoridentity: clinicInfo.Operatoridentity,
                id: clinicInfo.sysuser
              }
            ];
            that.billingDoctorList = doctorMaster.concat(res);
          } else {
            that.billingDoctorList = res;
          }
        })
        .catch((err) => { });
    },
    //切换开单医生
    chooseBillingDoctor(event, documentno) {
      const that = this;
      that.billingDoctorList.map((item) => {
        if (item.id === event) {
          that.modifyDoctor(documentno, item.caa_full_name, item.id, 'second');
        }
      });
    },
    // 绑定、修改开单医生
    modifyDoctor(documentno, name, id, value) {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        orsl_Billing_doctor: name,
        orsl_Billing_doctor_ID: id,
        DocumentNo: documentno
      };
      const params = {
        token: clinicInfo.token,
        workid: '27a9ae13-fba9-dd79-2adb-b10f5afe1259',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          if (res.Order_summary_Library.IsOk === 'success') {
            if (value && value === 'first') {
              that.$message.success('恭喜，绑定开单医生成功');
            } else {
              that.$message.success('恭喜，修改开单医生成功');
            }
          }
        })
        .catch((err) => { });
    },
    // 获得管子颜色
    getCodeColor(code) {
      if (code) {
        for (var i = 0; i < codeImageList.length; i++) {
          if (codeImageList[i].psl_Default_sample_consumables_code == code) {
            return codeImageList[i].color;
          }
        }
      }
    },
    // 获得管子照片
    getCodeImage(code) {
      if (code) {
        // console.log('走走走组：：：', code);
        for (var i = 0; i < codeImageList.length; i++) {
          if (codeImageList[i].psl_Default_sample_consumables_code == code) {
            return codeImageList[i].img;
          }
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
/* 进度条 */
::v-deep .el-progress-circle {
  height: 36px !important;
  width: 36px !important;
}

/* dialog框 圆角 */
::v-deep .el-dialog__header {
  border-radius: 15px !important;
  padding: 0px !important;
}

::v-deep .el-dialog {
  border-radius: 15px !important;
}

/* 返回顶部背景改色 */
::v-deep .el-backtop {
  background: #b6d9fc !important;
}

/* 步进器宽度 */
::v-deep .el-input-number--medium {
  width: 152px !important;
}

/* 微信支付 */
.dialogWXAdd {

  // border: 1px solid rgb(217, 255, 0);
  .dialogWalletContent {
    height: 328px;

    // border: 1px solid red;
    #qrCodeAdd {
      background-color: white;
      height: 110px;
      width: 110px;
      position: absolute;
      z-index: 20;
      left: 94px;
      top: 155px;
    }

    #qrCodeAddZd {
      background-color: white;
      height: 110px;
      width: 110px;
      position: absolute;
      z-index: 20;
      left: 94px;
      top: 155px;
    }
  }

  .dialogWXBtn {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;

    // border: 1px solid rgb(29, 127, 207);
  }
}

/* --card-- */
.box-card {
  // min-height: calc(100vh - 225px);
  height: auto;
  margin-bottom: 20px;

  ::v-deep .el-card__header {
    padding: 0px 0px;
  }

  ::v-deep .el-card__body {
    padding: 0px 0px 20px 0px;
    // border: 1px solid red;
  }

  // 卡片头部区域样式
  .header {
    box-sizing: border-box;
    padding: 10px 30px;
    background-color: #f0feff;
    border-radius: 30px 30px 0px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @media screen and (max-width: 1024px) {
      padding: 10px 12px;
    }

    .header_title {
      font-size: 20px;
      color: #2d99d7;
    }

    .header_right {
      display: flex;

      .header_item {
        display: flex;
        align-items: center;
        align-content: center;
        margin: 0 5px;

        .item_title {
          color: #333;
          font-size: 16px;
          font-weight: 400;
          margin-right: 5px;
          margin-left: 20px;
          flex-shrink: 0;
        }

        &:first-child>.item_title {
          margin-left: 0;
        }

        @media screen and (max-width: 1024px) {
          .item_title {
            letter-spacing: 13px;
          }
        }

        ::v-deep .el-date-editor {
          width: 240px;
        }
      }
    }
  }

  .middle_table {
    // height: calc(100vh - 220px);
    height: auto;
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;
    // border: 1px solid red;
  }
}

//已选项目header部分
.order_title {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #dddddd;
  // border-bottom: 1px solid red;
  padding: 10px 0px;

  .title_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .el-button {
      margin-left: 10px;
    }

    .express_billing {
      width: 100px;
      height: 30px;
      background: #f6fcff;
      border: 1px solid #2d99d7;
      cursor: pointer;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #2d99d7;
      border-radius: 12px;
      box-sizing: border-box;
      user-select: none;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .more_test_text {
    width: 100px;
    height: 30px;
    background: #fff8ef;
    border: 1px solid #d89330;
    cursor: pointer;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #d89330;
    border-radius: 12px;
    box-sizing: border-box;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

//条码 科室检查区域
.orderBox {
  // border: 1px solid red;
  min-height: 400px;

  .orderCard {
    margin-top: 20px;
    margin-bottom: 20px;
    height: auto;
    // border: 1px solid green;
    width: calc(100vw - 160px);
    box-sizing: border-box;

    // 底部备注信息 开单医生样式
    .bottom_btn {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;
      padding: 0 20px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 550;
      color: #333333;
    }

    .orderContent {
      width: 100%;
      height: auto;
      // border: 1px solid rgb(94, 255, 0);
      box-sizing: border-box;
      padding: 15px;
      display: flex;
      justify-content: space-between;

      //支付区域
      // 右侧支付
      .payment_panel {
        width: 280px;

        // height: 480px;
        .pay_top {
          font-size: 14px;

          .password {
            display: flex;
            margin-bottom: 10px;
          }

          .main-title {
            font-size: 20px;
            font-weight: bolder;
            margin-right: 5px;
          }

          .subtitle {
            height: 32px;
            margin-top: 10px;
          }

          p {
            font-family: Source Han Sans CN;
            font-weight: 400;
          }
        }

        .pay_carousel {
          margin-top: 20px;

          // .swiper_image {
          //   width: 250px;
          //   height: 250px;
          // }
          .payWay {
            margin: 15px 0px;
            // border: 1px solid red;
            display: flex;

            .payType {
              cursor: pointer;
              height: 70px;
              width: 190px;
              border-radius: 10px;
              border: 1px solid #ebeef5;
              margin-right: 27px;
              // display: flex;
              // align-items: center;
              position: relative;

              .imageBox {
                margin-top: 5px;
                display: flex;
                justify-content: center;

                .payImage {
                  // border: 1px solid red;
                  width: 40px;
                  height: 40px;
                }
              }

              .label {
                margin-top: 5px;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                font-size: 14px;
                align-items: center;
              }

              .topTip {
                // border: 1px solid red;
                position: absolute;
                right: 0px;
                top: 0px;
              }
            }
          }
        }
      }

      .el-input-number ::v-deep .el-input__inner {
        text-align: left;
      }

      .section_bottom {
        .row {
          font-size: 12px;
          margin-bottom: 10px;

          .text-color-danger {
            font-size: 14px;
          }
        }
      }

      //支付区域结束

      .orderContent_left {
        // border: 1px solid red;
        width: 78%;
        height: auto;

        //科室检查样式
        .order_bottom {
          // height: 508px;
          height: auto;
          display: flex;
          justify-content: flex-start;
          border: 1px solid #f1e6e6;
          border-radius: 16px;
          box-sizing: border-box;

          .bottom_tm {
            width: 40px;
            // height: 508px;
            min-height: 210px; //科室检查盒子最低高度
            background: #f0feff;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: 16px;
            color: #2d99d7;
            font-weight: 700;
            box-sizing: border-box;
            border-radius: 16px 0 0 16px;
          }

          // 空
          .bottom_contentImage {
            flex: 1;
            height: 100%;
            // border: 2px solid red;
            padding: 10px 20px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          //非空
          .bottom_content {
            flex: 1;
            height: 100%;
            // border: 2px solid red;
            padding: 10px 20px;
            box-sizing: border-box;

            .department {
              height: 126px;
              width: 100%;
              // border-bottom: 1px dashed #b8b2b2;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              flex-wrap: wrap;

              .department_item {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                width: 250px;
                // border: 1px solid pink;
                margin-right: 45px;

                .item_input {
                  width: 180px;
                }

                // input框后插样式调整
                ::v-deep .el-input-group__append {
                  background-color: #fff !important;
                  padding: 0 10px !important;
                }
              }
            }

            .department_suggest {
              width: 100%;
              margin-top: 10px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;

              .suggest_top {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 100%;

                .top_title {
                  display: flex;
                  // justify-content: flex-start;

                  align-items: center;
                }

                .top_tagactive {
                  width: 55px;
                  height: 26px;
                  font-size: 14px;
                  color: #409eff;
                  border: 1px solid #409eff;
                  border-radius: 8px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  user-select: none;
                  margin-right: 15px;
                  cursor: pointer;
                }

                .top_tag {
                  width: 55px;
                  height: 26px;
                  font-size: 14px;
                  color: #999999;
                  border: 1px solid #999999;
                  border-radius: 8px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  user-select: none;
                  margin-right: 15px;
                  cursor: pointer;
                }
              }
            }
          }
        }

        // 条形码区域样式
        .order_left {
          display: flex;
          justify-content: flex-start;
          border: 1px solid #f1e6e6;
          border-radius: 16px;
          box-sizing: border-box;

          .left_tm {
            width: 40px;
            height: 140px;
            background: #f0feff;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: 16px;
            color: #2d99d7;
            font-weight: 700;
            box-sizing: border-box;
            border-radius: 16px 0 0 16px;
          }

          .left_content {
            flex: 1;
            height: 140px;
            // border: 1px solid rgb(118, 228, 15);
            padding: 10px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            overflow-x: auto;

            .code {
              box-sizing: border-box;
              width: 380px;
              height: 100px;
              // border: 1px solid rgb(11, 136, 238);
              border-radius: 16px;
              display: flex;
              justify-content: flex-start;
              margin-right: 20px;

              .code_img {
                width: 100px;
                height: 100px;
                border-radius: 16px;
                overflow: hidden;
              }

              .code_right {
                box-sizing: border-box;
                width: 280px;
                padding: 0 15px;

                // border: 3px solid rgb(12, 241, 192);
                .code_right_top {
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;

                  .code_inner_right {
                    width: 40px;
                    height: 25px;
                    background: #abd6ef;
                    border-radius: 10px;
                    margin-right: 20px;
                  }
                }

                .code_right_bottom {
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                }
              }
            }
          }
        }
      }
    }

    //基本信息填写
    .info {
      padding: 10px 15px;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;

      .info_right {
        margin-left: 60px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        user-select: none;
      }
    }

    .info2 {
      font-size: 15px;
      color: #666666;
      padding: 0px 15px;
      // margin-bottom: 10px;
    }

    // 订单编号
    .title {
      box-sizing: border-box;
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-weight: 700;
      font-style: normal;
      font-size: 16px;
      color: #2d99d7;
      background: #f0feff;
      display: flex;
      justify-content: flex-start;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      user-select: none;

      .deleteBtn {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 20px;
      }

      .orderTip {
        width: 75px;
        height: 50px;

        .orderTipTop {
          width: 75px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          font-weight: 700;
          font-style: normal;
          font-size: 12px;
          color: #ffffff;
          background: rgba(33, 204, 160, 1);
          border-radius: 0px 3px 0px 0px;
        }

        .orderTipTopAct {
          width: 75px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          font-weight: 700;
          font-style: normal;
          font-size: 12px;
          color: #ffffff;
          background: rgb(181, 184, 183);
          border-radius: 0px 3px 0px 0px;
        }

        .orderTipBottom {
          width: 75px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          font-weight: 700;
          font-style: normal;
          font-size: 12px;
          color: #ffffff;
          background: rgba(223, 174, 24, 1);
          border-radius: 0px 0px 3px 0px;
        }
      }
    }
  }

  /* 订单卡片padding*/
  ::v-deep .el-card__body {
    padding: 0px !important;
  }
}

.body {
  box-sizing: border-box;
  margin-top: 10px;

  // margin-right: 20px;
  //选择区域 提交订单区域
  .order {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .tips {
      font-weight: 700;
      font-size: 20px;
      color: #f04562;
    }

    .tips_two {
      font-weight: 700;
      font-size: 20px;
      color: #030303;
    }
  }

  // 选择患者区域
  .patient_hrader {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tip_content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .tip {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }

      .tip_btn {
        width: 100px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #31bfc5;
        background: #f0feff;
        border: 1px solid #31bfc5;
        margin-left: 30px;
        border-radius: 12px;
        box-sizing: border-box;
        user-select: none;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  // 已选项目区域
  .choose_item_notitems {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    // border: 1px solid darkcyan;
    height: 206px;
  }

  .choose_item {
    // border: 1px solid pink;
    // min-height: 200px;
    min-height: calc(100vh - 600px);
    // overflow-y: auto;
    padding-right: 15px;

    .item {
      height: 40px;
      background: #f6fcff;
      border: 1px solid #d5ebf7;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px 0 15px;
      margin-bottom: 6px;

      .item_left {
        display: flex;
        justify-content: flex-start;

        .item_name {
          font-size: 14px;
          font-family: Source Han Sans CN;
          // font-weight: 700;
          color: #333333;
          user-select: none;
        }

        .title_image {
          width: 16px;
          height: 16px;
          margin-left: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .item_workday {
          width: 86px;
          height: 23px;
          background: #e2f5ff;
          border-radius: 12px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2d99d7;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 30px;
          box-sizing: border-box;
          user-select: none;
        }

        .item_price {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 800;
          color: #f04562;

          user-select: none;
        }
      }

      .item_remove {
        cursor: pointer;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #2d99d7;
        user-select: none;
      }
    }
  }
}

// 弹出层那边样式
.patient_dialogheader {
  // width: 1724px;
  height: 58px;
  background: #f0feff;
  border-radius: 15px !important;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .dialog_title {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #2d99d7;
    margin: 0 112px 0 31px;
  }
}

// 更多检验区域
.more_test {
  // width: 65%;
  height: calc(100vh - 280px);
  border-radius: 15px !important;
  // border: 1px solid red;
}

.zdDialog {
  width: 100%;
  height: 160px;

  // border: 1px solid red;
  .zdTitle {
    text-align: center;
    font-size: 18px;
    color: #303133;
    margin-bottom: 10px;
  }

  .zdTip {
    color: #606266;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .zdTip2 {
    color: #2d99d7;
    font-size: 14px;
    text-align: center;
  }

  .zdInput {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
